import type { MessageKey } from './pt';

export const en: Record<MessageKey, string> = {
  brand: 'DeytanPlay',
  tagline: 'Quick mobile games — have fun and challenge friends.',
  heroTitle: 'Pick a game',
  heroSubtitle: 'Lightweight, mobile-first portal. No download.',
  playNow: 'Play',
  comingSoon: 'Coming soon',
  newBadge: 'New',
  backHome: 'Back',
  themeSystem: 'System',
  themeLight: 'Light',
  themeDark: 'Dark',
  language: 'Language',
  privacy: 'Privacy',
  terms: 'Terms',
  footerNote: 'Made with ☕ by DeytanLab',
  privacyStub: 'Privacy policy coming soon.',
  termsStub: 'Terms of use coming soon.',

  gameWordleTitle: 'Wordle',
  gameWordleDescription: 'Guess the word in a few tries and challenge a friend.',

  wordleMenuTitle: 'Wordle',
  wordleMenuSubtitle: 'Pick length and dictionary before playing. Attempts = length + 1.',
  wordleLengthLabel: 'Word length',
  wordleLengthHint: '{length} letters · {attempts} attempts',
  wordleGameLangLabel: 'Game dictionary',
  wordleDictPt: 'Portuguese',
  wordleDictEn: 'English',
  wordleDictBadge: 'Dictionary: {dict}',
  wordlePlayRandom: 'Play random',
  wordleCreateChallenge: 'Create challenge',
  wordleCustomWord: 'Challenge word',
  wordleCustomPlaceholder: 'E.g.: PORTA',
  wordleOptionalNick: 'Your nickname (optional)',
  wordleNickPlaceholder: 'E.g.: Ana',
  wordleCreateLink: 'Generate challenge link',
  wordleInvalidCustom: 'Use letters A–Z only, 4 to 8 characters.',
  wordleNotInDictionary: 'Word is not in the dictionary.',
  wordleTooShort: 'Complete the word.',
  wordleAlreadyGuessed: 'You already tried that word.',
  wordleEnter: 'ENTER',
  wordleBack: '⌫',
  wordleWon: 'Got it in {attempts} try(ies)!',
  wordleLost: 'The word was {word}.',
  wordleShareChallenge: 'Challenge a friend',
  wordleShareResult: 'Share result',
  wordleCounterChallenge: 'Challenge back',
  wordleCounterRandom: 'Random challenge',
  wordleCounterCustom: 'Custom challenge',
  wordleNewGame: 'New game',
  wordleInvalidLink: 'This challenge link is invalid.',
  wordleChallengeFrom: '{name} challenged you!',
  wordleChallengeFromAnon: 'Someone challenged you!',
  wordleChallengerResult: 'Solved in {attempts} try(ies).',
  wordleChallengerLost: "Didn't get it — can you do better?",
  wordleShareTextChallenge:
    'I challenged you on DeytanPlay Wordle! {length}-letter word. Can you solve it?',
  wordleShareTextResult: 'I solved DeytanPlay Wordle in {attempts} try(ies)!',
  wordleShareTextCounter: 'Got it! Now I challenge you back on DeytanPlay Wordle.',
  wordleCopyLink: 'Link copied!',
  wordleShareFailed: 'Could not share. Try copying the link.',
  wordleLoadingDict: 'Loading dictionary…',
  wordleAttemptsLeft: '{n} attempt(s) left',
};
